import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { About } from "@/components/landing/About";
import { Benefits } from "@/components/landing/Benefits";
import { Membership } from "@/components/landing/Membership";
import { Footer } from "@/components/landing/Footer";
import { PromoBanner } from "@/components/landing/PromoBanner";
import { PromoPopup } from "@/components/landing/PromoPopup";

export const LandingPage = () => {
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.search.includes("nolenis")) return;
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id === "#" || !id) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onClick);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    window.__lenis = lenis;
    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain bg-zinc-950" data-testid="app-root">
      <PromoBanner />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Benefits />
        <Membership />
      </main>
      <Footer />
      <PromoPopup />
    </div>
  );
};
